import { apiWithkey } from "../axios";
import { getRangesApi, baseApiURL } from "../endpoints";
import { useConsorcioStore } from "../../storeModules/useConsorcioStore";
import { useInitialConfigStore } from "../../storeModules/useInitialConfigStore";
import { Catalog } from "../../utils/constants";
import DatadogErrorReporter from "../../utils/datadogErrorReporter";
import GetRangeError from "../../utils/customErrors/getRangeError";

const getRanges = async () => {
  const { categoriaId } = useConsorcioStore.getState();
  const { empresaId, tipoTabela } = useInitialConfigStore.getState();

  const pagaIntegral = tipoTabela.includes("integral");
  const pagaReduzida = tipoTabela.includes("reduzida");
  const pagaMetade = tipoTabela.includes("metade");

  const sigla = Catalog.category[categoriaId];

  const url = `${baseApiURL}${getRangesApi}?empresaId=${empresaId}&pagaIntegral=${pagaIntegral}&pagaReduzida=${pagaReduzida}&pagaMetade=${pagaMetade}&categorias=${sigla}`;

  return apiWithkey
    .get(url)
    .then((response) => {
      const { data } = response.data;
      return data;
    })
    .catch((error) => {
      DatadogErrorReporter.reportApiError(
        new GetRangeError(error, url, {
          empresaId,
          pagaIntegral,
          pagaReduzida,
          pagaMetade,
          categorias: sigla,
        })
      );
    });
};

export default getRanges;
